import { render, staticRenderFns } from "./VaccineRegistrationsCreatedTable.vue?vue&type=template&id=038147f6&"
import script from "./VaccineRegistrationsCreatedTable.vue?vue&type=script&lang=js&"
export * from "./VaccineRegistrationsCreatedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VListItem,VListItemContent,VListItemTitle,VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('038147f6')) {
      api.createRecord('038147f6', component.options)
    } else {
      api.reload('038147f6', component.options)
    }
    module.hot.accept("./VaccineRegistrationsCreatedTable.vue?vue&type=template&id=038147f6&", function () {
      api.rerender('038147f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VaccineViews/VaccineRegistrationPage/components/VaccineRegistrationsCreatedTable.vue"
export default component.exports